import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesOverview.css';
import SEO from '../../components/SEO/SEO';


const ServicesOverview = () => {
    return (
        <div className="services-overview-page">
            <SEO
                title="All Digital Marketing Services"
                description="Discover all of Digi Network's digital marketing services including SEO, Paid Advertising, Web Development, and Email Marketing."
                canonical="/services-overview"
            />
            {/* Hero Section */}
            <section className="services-overview-hero">
                <div className="services-overview-hero-bg"></div>
                <div className="container">
                    <div className="services-overview-hero-content">
                        <div className="label">Our Services</div>
                        <h1>Everything You Need to Grow Online</h1>
                        <p>Digi Network combines technical expertise, creative execution, and data-driven strategies to deliver full-funnel marketing solutions. From dominating search results to running high-converting ad campaigns and building stunning websites — we've got you covered.</p>
                    </div>
                </div>
            </section>

            {/* Main Services Grid */}
            <section className="main-services-section">
                <div className="container">
                    <div className="main-services-grid">
                        {/* SEO Services */}
                        <div className="main-service-card">
                            {/* IMAGE PLACEHOLDER: Add SEO dashboard or ranking screenshot here (recommended size: 100% width, 250px height) */}
                            <div className="service-card-image">
                                <div className="service-card-image-placeholder">
                                    <p>📊 Add SEO Screenshot</p>
                                </div>
                            </div>
                            <div className="main-service-icon">🔍</div>
                            <h2>SEO Services</h2>
                            <p>Dominate search results through technical excellence, content optimization, and authority growth. We help businesses rank higher, drive organic traffic, and increase conversions.</p>

                            <ul className="service-highlights">
                                <li>On-Page SEO & Content Optimization</li>
                                <li>Off-Page SEO & Link Building</li>
                                <li>Technical SEO Audits</li>
                                <li>Local & International SEO</li>
                            </ul>

                            <Link to="/seo-services" className="btn btn-primary">
                                Explore SEO Services
                                <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                                </svg>
                            </Link>
                        </div>

                        {/* Paid Advertising */}
                        <div className="main-service-card">
                            {/* IMAGE PLACEHOLDER: Add ad dashboard or campaign screenshot here (recommended size: 100% width, 250px height) */}
                            <div className="service-card-image">
                                <div className="service-card-image-placeholder">
                                    <p>📈 Add Ad Dashboard</p>
                                </div>
                            </div>
                            <div className="main-service-icon">📈</div>
                            <h2>Paid Advertising</h2>
                            <p>Run high-ROI campaigns that convert clicks into customers. Our full-funnel ad strategies with real-time optimization ensure maximum returns on every dollar spent.</p>

                            <ul className="service-highlights">
                                <li>Meta Ads (Facebook & Instagram)</li>
                                <li>Google Ads (Search, Display, Shopping)</li>
                                <li>LinkedIn B2B Advertising</li>
                                <li>TikTok Performance Campaigns</li>
                            </ul>

                            <Link to="/paid-ads" className="btn btn-primary">
                                Explore Paid Ads
                                <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                                </svg>
                            </Link>
                        </div>

                        {/* Web Development */}
                        <div className="main-service-card">
                            {/* IMAGE PLACEHOLDER: Add website screenshot or design mockup here (recommended size: 100% width, 250px height) */}
                            <div className="service-card-image">
                                <div className="service-card-image-placeholder">
                                    <p>💻 Add Website Screenshot</p>
                                </div>
                            </div>
                            <div className="main-service-icon">💻</div>
                            <h2>Web Development & Design</h2>
                            <p>Fast, responsive, and visually stunning websites designed to convert visitors into leads. We build digital experiences that drive real business results.</p>

                            <ul className="service-highlights">
                                <li>Custom React & Next.js Websites</li>
                                <li>WordPress Development</li>
                                <li>Shopify E-Commerce Development</li>
                                <li>Webflow Design & Development</li>
                                <li>UX-Driven Conversion Optimization</li>
                            </ul>

                            <Link to="/web-development" className="btn btn-primary">
                                Explore Web Services
                                <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                                </svg>
                            </Link>
                        </div>

                        {/* Email Marketing */}
                        <div className="main-service-card">
                            {/* IMAGE PLACEHOLDER: Add email marketing dashboard here (recommended size: 100% width, 250px height) */}
                            <div className="service-card-image">
                                <div className="service-card-image-placeholder">
                                    <p>📧 Add Email Dashboard</p>
                                </div>
                            </div>
                            <div className="main-service-icon">✉️</div>
                            <h2>Email Marketing</h2>
                            <p>Build lasting relationships with customers through strategic email campaigns. Automated sequences that nurture leads and drive conversions.</p>

                            <ul className="service-highlights">
                                <li>Email Campaign Strategy</li>
                                <li>Marketing Automation</li>
                                <li>Template Design & Optimization</li>
                                <li>Performance Analytics</li>
                            </ul>

                            <Link to="/services/email-marketing" className="btn btn-primary">
                                Explore Email Services
                                <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                                </svg>
                            </Link>
                        </div>

                        {/* GoHighLevel */}
                        <div className="main-service-card">
                            {/* IMAGE PLACEHOLDER: Add GoHighLevel dashboard here (recommended size: 100% width, 250px height) */}
                            <div className="service-card-image">
                                <div className="service-card-image-placeholder">
                                    <p>📊 Add GHL Dashboard</p>
                                </div>
                            </div>
                            <div className="main-service-icon">📊</div>
                            <h2>GoHighLevel Platform</h2>
                            <p>All-in-one marketing platform combining email, SMS, CRM, automation, and analytics. Complete setup, training, and ongoing management.</p>

                            <ul className="service-highlights">
                                <li>Platform Setup & Configuration</li>
                                <li>Email & SMS Marketing</li>
                                <li>CRM & Lead Management</li>
                                <li>Automation & Analytics</li>
                            </ul>

                            <Link to="/services/gohighlevel" className="btn btn-primary">
                                Explore GoHighLevel
                                <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Digi Network */}
            <section className="why-digi-network">
                <div className="container">
                    <h2>Why Choose Digi Network?</h2>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Full-Funnel Expertise</h3>
                            <p>We don't just drive traffic — we optimize every step from awareness to conversion, ensuring maximum ROI.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Data-Driven Decisions</h3>
                            <p>Every strategy is backed by analytics, A/B testing, and performance insights to continuously improve results.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Proven Track Record</h3>
                            <p>We've helped businesses across UAE and internationally achieve 300%+ growth in organic traffic and ad conversions.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Transparent Reporting</h3>
                            <p>Monthly performance reports with clear KPIs, insights, and recommendations — no fluff, just results.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="services-overview-cta">
                <div className="container">
                    <h2>Ready to Accelerate Your Growth?</h2>
                    <p>Let's discuss which services align with your business goals</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default ServicesOverview;
